<template>
  <BlBackdrop
    title="Edit contact information"
    label="Update"
    :disabled="isDisabledSubmit"
    :submitLoading="submitLoading"
    @backdrop-close="$emit('close-modal')"
    @backdrop-action="onUpdate"
  >
    <div
      class="flex flex-col gap-5 px-8"
      :style="{ width: '40rem', maxHeight: 'calc(100vh - 14rem)' }"
    >
      <div class="py-4 grid grid-cols-6 items-center gap-4">
        <BlInputText
          class="col-span-6"
          :input="contactNameInput"
          @changed="inputHandler"
        />
        <!--  -->
        <BlInputText
          class="col-span-3"
          :input="contactEmailInput"
          @changed="inputHandler"
        />
        <BlInputText
          class="col-span-3"
          :input="contactPhoneNumberInput"
          @changed="inputHandler"
        />
        <!--  -->
        <BlInputText
          class="col-span-6"
          :input="centerAddressInput"
          @changed="inputHandler"
        />
      </div>
    </div>
  </BlBackdrop>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import BlBackdrop from "../../../BlBackdrop.vue";
import BlTextSubtitle1 from "../../../BlTextSubtitle1.vue";
import BlInputText from "../../../BlInputText.vue";
import BlSelectBox from "../../../BlSelectBox.vue";

export default {
  name: "EditContactInformationModal",
  components: {
    BlBackdrop,
    BlTextSubtitle1,
    BlInputText,
    BlSelectBox
  },
  props: {},
  data() {
    return {
      submitLoading: false,
      contactNameInput: {
        label: "Contact person name",
        placeholder: "Type name",
        model: ""
      },
      contactEmailInput: {
        label: "Email",
        placeholder: "Type email",
        model: ""
      },
      contactPhoneNumberInput: {
        label: "Phone number",
        placeholder: "Type phone number",
        model: ""
      },
      centerAddressInput: {
        label: "Center address",
        placeholder: "Type address",
        textarea: true,
        model: ""
      }
    };
  },
  computed: {
    ...mapGetters(["currentUser", "center"]),
    isDisabledSubmit() {
      return false;
    }
  },
  watch: {},
  mounted() {
    this.contactNameInput.model = this.center.contact_name;
    this.contactEmailInput.model = this.center.contact_email;
    this.contactPhoneNumberInput.model = this.center.contact_phone_number;
    this.centerAddressInput.model = this.center.center_address;
  },
  methods: {
    ...mapActions(["updateCenter"]),
    inputHandler(payload) {
      payload.input.model = payload.value;
    },
    async onUpdate() {
      const params = {
        id: this.center.id,
        center: {
          contact_name: this.contactNameInput.model,
          contact_email: this.contactEmailInput.model,
          contact_phone_number: this.contactPhoneNumberInput.model,
          center_address: this.centerAddressInput.model
        },
        title: `Contact information updated`,
        message: `Success! The contact information has been updated.`
      };

      this.submitLoading = true;
      const { success } = await this.updateCenter(params);
      this.submitLoading = false;
      if (!success) return;
      this.$emit("close-modal");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/superAdmin/center/centerInformation/EditContactInformationModal.vue